import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, ToastService } from '@app/services';
import { MessageType } from '@app/shared';

@Component({
  selector: 'app-homepage',
  templateUrl: 'homepage.component.html',
  styleUrls: ['homepage.component.scss'],
})
export class HomePageComponent {
  constructor(
    public translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private toastService: ToastService,
  ) {
    if (!authService.isLoggedIn) translate.use(translate.defaultLang);
  }

  navigate(route: string) {
    return this.router.navigate([route]);
  }

  async redirect() {
    try {
      const { url } = await this.authService.redirectSSO();
      window.open(url, '_self');
    } catch (error) {
      console.error(error);
      this.toastService.showToast(MessageType.ERROR);
    }
  }
}
